import React from 'react';
import "./skills.css";
import "./skills.scss";
import { SiCypress, SiJest, SiJunit5, SiStorybook, SiPlaywright } from "react-icons/si";
import { FaLocust } from "react-icons/fa6";


const Frameworks = () => {
  return (
    <div className="skills__content box-bottom-left">
        <h3 className="skills__title">Testing & Others</h3>

        <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                    <SiJest size={20} />
                    <div>
                        <h3 className="skills__name">Jest</h3>
                        <span className="skills__level"></span>
                    </div>
                </div>

                <div className="skills__data">
                    <SiCypress size={20} />
                    <div>
                        <h3 className="skills__name">Cypress</h3>
                        <span className="skills__level"></span>
                    </div>
                </div>

                <div className="skills__data">
                    <SiPlaywright size={20} />
                    <div>
                        <h3 className="skills__name">Playwright</h3>
                        <span className="skills__level"></span>
                    </div>
                </div>
            </div>

            <div className="skills__group">
                <div className="skills__data">
                    <SiJunit5 size={20} />
                    <div>
                        <h3 className="skills__name">JUnit</h3>
                        <span className="skills__level"></span>
                    </div>
                </div>

                <div className="skills__data">
                    <FaLocust size={20} />
                    <div>
                        <h3 className="skills__name">Locust</h3>
                        <span className="skills__level"></span>
                    </div>
                </div>

                <div className="skills__data">
                    <SiStorybook size={20} />
                    <div>
                        <h3 className="skills__name">Storybook</h3>
                        <span className="skills__level"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Frameworks